/**
 * Curated list of US/CAN/MX freight-relevant cities with lat/lng.
 * Used to power the autocomplete in /book-load and elsewhere.
 *
 * Roughly: every metro of 250k+ population, every major port,
 * every major freight DC hub (Memphis, Louisville, Columbus, etc.).
 */
export const FREIGHT_CITIES = [
  // ---- Top 50 US metros ----
  { city: "New York, NY",        lat: 40.7128, lng: -74.0060 },
  { city: "Los Angeles, CA",     lat: 34.0522, lng: -118.2437 },
  { city: "Chicago, IL",         lat: 41.8781, lng: -87.6298 },
  { city: "Houston, TX",         lat: 29.7604, lng: -95.3698 },
  { city: "Phoenix, AZ",         lat: 33.4484, lng: -112.0740 },
  { city: "Philadelphia, PA",    lat: 39.9526, lng: -75.1652 },
  { city: "San Antonio, TX",     lat: 29.4241, lng: -98.4936 },
  { city: "San Diego, CA",       lat: 32.7157, lng: -117.1611 },
  { city: "Dallas, TX",          lat: 32.7767, lng: -96.7970 },
  { city: "Austin, TX",          lat: 30.2672, lng: -97.7431 },
  { city: "Jacksonville, FL",    lat: 30.3322, lng: -81.6557 },
  { city: "Fort Worth, TX",      lat: 32.7555, lng: -97.3308 },
  { city: "Columbus, OH",        lat: 39.9612, lng: -82.9988 },
  { city: "Indianapolis, IN",    lat: 39.7684, lng: -86.1581 },
  { city: "Charlotte, NC",       lat: 35.2271, lng: -80.8431 },
  { city: "San Francisco, CA",   lat: 37.7749, lng: -122.4194 },
  { city: "Seattle, WA",         lat: 47.6062, lng: -122.3321 },
  { city: "Denver, CO",          lat: 39.7392, lng: -104.9903 },
  { city: "Washington, DC",      lat: 38.9072, lng: -77.0369 },
  { city: "Nashville, TN",       lat: 36.1627, lng: -86.7816 },
  { city: "Oklahoma City, OK",   lat: 35.4676, lng: -97.5164 },
  { city: "El Paso, TX",         lat: 31.7619, lng: -106.4850 },
  { city: "Boston, MA",          lat: 42.3601, lng: -71.0589 },
  { city: "Portland, OR",        lat: 45.5152, lng: -122.6784 },
  { city: "Las Vegas, NV",       lat: 36.1699, lng: -115.1398 },
  { city: "Detroit, MI",         lat: 42.3314, lng: -83.0458 },
  { city: "Memphis, TN",         lat: 35.1495, lng: -90.0490 },
  { city: "Louisville, KY",      lat: 38.2527, lng: -85.7585 },
  { city: "Baltimore, MD",       lat: 39.2904, lng: -76.6122 },
  { city: "Milwaukee, WI",       lat: 43.0389, lng: -87.9065 },
  { city: "Albuquerque, NM",     lat: 35.0844, lng: -106.6504 },
  { city: "Tucson, AZ",          lat: 32.2226, lng: -110.9747 },
  { city: "Fresno, CA",          lat: 36.7378, lng: -119.7871 },
  { city: "Sacramento, CA",      lat: 38.5816, lng: -121.4944 },
  { city: "Kansas City, MO",     lat: 39.0997, lng: -94.5786 },
  { city: "Atlanta, GA",         lat: 33.7490, lng: -84.3880 },
  { city: "Miami, FL",           lat: 25.7617, lng: -80.1918 },
  { city: "Raleigh, NC",         lat: 35.7796, lng: -78.6382 },
  { city: "Omaha, NE",           lat: 41.2565, lng: -95.9345 },
  { city: "Long Beach, CA",      lat: 33.7701, lng: -118.1937 },
  { city: "Virginia Beach, VA",  lat: 36.8529, lng: -75.9780 },
  { city: "Oakland, CA",         lat: 37.8044, lng: -122.2712 },
  { city: "Minneapolis, MN",     lat: 44.9778, lng: -93.2650 },
  { city: "Tulsa, OK",           lat: 36.1540, lng: -95.9928 },
  { city: "Arlington, TX",       lat: 32.7357, lng: -97.1081 },
  { city: "Wichita, KS",         lat: 37.6872, lng: -97.3301 },
  { city: "New Orleans, LA",     lat: 29.9511, lng: -90.0715 },
  { city: "Cleveland, OH",       lat: 41.4993, lng: -81.6944 },
  { city: "Tampa, FL",           lat: 27.9506, lng: -82.4572 },
  { city: "Bakersfield, CA",     lat: 35.3733, lng: -119.0187 },
  // ---- Freight / DC hubs ----
  { city: "Allentown, PA",       lat: 40.6084, lng: -75.4902 },
  { city: "Harrisburg, PA",      lat: 40.2732, lng: -76.8867 },
  { city: "Reno, NV",            lat: 39.5296, lng: -119.8138 },
  { city: "Salt Lake City, UT",  lat: 40.7608, lng: -111.8910 },
  { city: "Des Moines, IA",      lat: 41.5868, lng: -93.6250 },
  { city: "Eden Prairie, MN",    lat: 44.8547, lng: -93.4708 },
  { city: "Holland, MI",         lat: 42.7875, lng: -86.1089 },
  { city: "Golden Valley, MN",   lat: 44.9889, lng: -93.3514 },
  { city: "Greenville, SC",      lat: 34.8526, lng: -82.3940 },
  { city: "Spartanburg, SC",     lat: 34.9496, lng: -81.9320 },
  { city: "Cincinnati, OH",      lat: 39.1031, lng: -84.5120 },
  { city: "Birmingham, AL",      lat: 33.5186, lng: -86.8104 },
  { city: "Mobile, AL",          lat: 30.6954, lng: -88.0399 },
  { city: "Savannah, GA",        lat: 32.0809, lng: -81.0912 },
  { city: "Norfolk, VA",         lat: 36.8508, lng: -76.2859 },
  { city: "Newark, NJ",          lat: 40.7357, lng: -74.1724 },
  { city: "Toledo, OH",          lat: 41.6528, lng: -83.5379 },
  { city: "St. Louis, MO",       lat: 38.6270, lng: -90.1994 },
  { city: "Pittsburgh, PA",      lat: 40.4406, lng: -79.9959 },
  { city: "Buffalo, NY",         lat: 42.8864, lng: -78.8784 },
  { city: "Rochester, NY",       lat: 43.1566, lng: -77.6088 },
  { city: "Boise, ID",           lat: 43.6150, lng: -116.2023 },
  { city: "Spokane, WA",         lat: 47.6588, lng: -117.4260 },
  { city: "Anchorage, AK",       lat: 61.2181, lng: -149.9003 },
  { city: "Honolulu, HI",        lat: 21.3069, lng: -157.8583 },
  { city: "San Bernardino, CA",  lat: 34.1083, lng: -117.2898 },
  { city: "Riverside, CA",       lat: 33.9533, lng: -117.3962 },
  { city: "Stockton, CA",        lat: 37.9577, lng: -121.2908 },
  { city: "Ontario, CA",         lat: 34.0633, lng: -117.6509 },
  { city: "Lazaro Cardenas, MX", lat: 17.9583, lng: -102.2008 },
  // ---- Canada ----
  { city: "Toronto, ON",         lat: 43.6532, lng: -79.3832 },
  { city: "Montreal, QC",        lat: 45.5017, lng: -73.5673 },
  { city: "Vancouver, BC",       lat: 49.2827, lng: -123.1207 },
  { city: "Calgary, AB",         lat: 51.0447, lng: -114.0719 },
  { city: "Winnipeg, MB",        lat: 49.8951, lng: -97.1384 },
  // ---- Mexico ----
  { city: "Mexico City, MX",     lat: 19.4326, lng: -99.1332 },
  { city: "Monterrey, MX",       lat: 25.6866, lng: -100.3161 },
  { city: "Guadalajara, MX",     lat: 20.6597, lng: -103.3496 },
  { city: "Tijuana, MX",         lat: 32.5149, lng: -117.0382 },
  { city: "Laredo, TX",          lat: 27.5036, lng: -99.5076 },
];

export const CITY_NAMES = FREIGHT_CITIES.map(c => c.city);

export function lookupCity(name) {
  if (!name) return null;
  const norm = name.trim().toLowerCase();
  return FREIGHT_CITIES.find(c => c.city.toLowerCase() === norm) || null;
}
